export default class Picklist {
    DPD_BUCKET: string[];
    STATUS: string[];
    LOAN_TYPE: string[];
    USER_ROLE: string[];
    VALUE_TYPE: string[];
    INTERACTION_TYPE: string[];
    DISPOSITION_INPUT_TYPE: string[];

    constructor(
        dpdBuckets: string[],
        statuses: string[],
        loanTypes: string[],
        userRoles: string[],
        valueTypes: string[],
        interactionTypes: string[],
        dispositionInputTypes: string[]
    ) {
        this.DPD_BUCKET = dpdBuckets;
        this.STATUS = statuses;
        this.LOAN_TYPE = loanTypes;
        this.USER_ROLE = userRoles;
        this.VALUE_TYPE = valueTypes;
        this.INTERACTION_TYPE = interactionTypes;
        this.DISPOSITION_INPUT_TYPE = dispositionInputTypes;
    }

    public static createDefault() {
        const picklist = new Picklist([], [], [], [], [], [], []);
        return picklist;
    }
}